import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "../views/Login.vue";
import Session_Cal from "../views/edu/Sessions.vue";
import Tasks from "../views/edu/Assignment.vue";
import EventListReg2 from "../views/EventListReg2.vue";
//import EventListReg3 from "../views/admin-EventListReg2.vue";
import Profile from "../views/MyProfile.vue";
// import ClientLobby from "../views/ClientLobby.vue";
//import { languages } from '@/plugins/i18n'
//import store from '@/store'
// import App from '@/App.vue'

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: "/",
		name: "Login",
		component: Login
		//component: () => import(/* webpackChunkName: "about" */ '../views/puc.vue')
	},
	{
		path: "/admin",
		name: "Login",
		component: Login
		//component: () => import(/* webpackChunkName: "about" */ '../views/puc.vue')
	},
	{
		path: "/eventlogin/:cid?/:eid?",
		name: "eventlogin",
		component: Login
	},
	{
		path: "/preview/:eid?",
		name: "previewlogin",
		component: Login
	},
	{
		path: "/tasks",
		name: "tasks",
		component: Tasks
	},
	// {
	// 	path: '/:lang',
	// 	component: Login,
	// 	beforeEnter(to, from, next) {
	// 		let lang = to.params.lang
	// 		if (languages.includes(lang)) {
	// 			if (store.state.locale !== lang) {
	// 				store.dispatch('changeLocale', lang)
	// 			}
	// 			return next()
	// 		}
	// 		return next({ path: store.state.locale })
	// 	}
	// },
	{
		path: "/session_cal/:tabid?",
		name: "session_cal",
		component: Session_Cal
	},
	{
		path: "/404",
		name: "404",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Error404.vue")
	},
	{
		path: "/edu_reports",
		name: "Edu Reports",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../components/edu/Reports.vue")
	},
	{
		path: "*",
		redirect: "/404"
	},
	{
		path: "/SiteLogin",
		name: "SiteLogin",
		component: Login
	},
	{
		path: "/meeting-home",
		name: "MeetingHome",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Player/pages/Home.vue")
	},
	
	// {
	// 	path: "/home",
	// 	name: "Home",
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ "../views/Home.vue")
	// },
	{
		path: "/home",
		name: "Home",
		// path: "/home-uat",
		// name: "HomeUAT",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/HomeUAT.vue")
	},
	{
		path: "/youthambassadors",
		name: "YouthAmbassadors",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/YouthAmbassadors.vue")
	},
	{
		path: "/about",
		name: "About",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
	},
	{
		path: "/briefcase",
		name: "Briefcase",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Briefcase.vue")
	},
	{
		path: "/stageview/:id?/:tid?",
		name: "StageView",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/StageView.vue")
	},
	{
		path: "/admin-stageview/:id?/:tid?",
		name: "AdminStageView",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/StageView.vue")
	},
	{
		path: "/stageviewng/:id?/:tid?",
		name: "StageViewNG",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/StageViewNG.vue")
	},
	{
		path: "/admin-stageviewng/:id?/:tid?",
		name: "AdminStageViewNG",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/StageViewNG.vue")
	},
	{
		path: "/livestage/:id?/:tid?",
		name: "LiveStage",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/LiveStageNG.vue")
	},
	{
		path: "/livestageng/:id?/:tid?",
		name: "LiveStageNG",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/LiveStageNG.vue")
	},
	//{
	//	path: '/livestage2/:tid?',
	//	name: 'LiveStage1',
	//	// route level code-splitting
	//	// this generates a separate chunk (about.[hash].js) for this route
	//	// which is lazy-loaded when the route is visited.
	//	component: () => import(/* webpackChunkName: "about" */ '../views/LiveStage_BeforeRemoveHeader.vue')
	//},
	//{
	//	path: '/livestage1',
	//	name: 'LiveStage1',
	//	// route level code-splitting
	//	// this generates a separate chunk (about.[hash].js) for this route
	//	// which is lazy-loaded when the route is visited.
	//	component: () => import(/* webpackChunkName: "about" */ '../views/LiveStage1.vue')
	//},
	{
		path: "/pollresult/:cid?/:eid?/:sid?/:srvid?/:qid?",
		name: "PollResult",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/PollResult.vue")
	},
	{
		path: "/exhibitor",
		name: "ExhibitorList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExhibitorList.vue")
	},
	{
		path: "/dashboard",
		name: "AdminDashboard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminDashboard.vue")
	},
	// {
	// 	path: "/mobilepreview",
	// 	name: "Stage Mobile Preview",
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () =>
	// 		import(/* webpackChunkName: "about" */ "../views/MobilePreview.vue")
	// },
	{
		path: "/speakeradd",
		name: "SpeakerAddPopup",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SpeakerAddPopup.vue")
	},
	{
		path: "/bulkupload",
		name: "BulkUpload",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/BulkUpload.vue")
	},
	{
		path: "/inviteuser",
		name: "Invite User",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/InviteUser.vue")
	},
	{
		path: "/mainlobby",
		name: "MainLobby",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ClientLobby.vue"),
		children: [
			{
				path: "tasks",
				name: "MainLobbyTasks",
				component: Tasks
			},
			{
				path: "session_cal/:tabid?",
				name: "MainLobbySessionCal",
				component: Session_Cal
			},
			{
				path: "myprofile",
				name: "MainLobbyProfile",
				component: Profile
			},
			{
				path: "speakers",
				name: "MainLobbySpeakers",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/SpeakerList.vue")
			},
			{
				path: "course-details",
				name: "CourseOverview",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/CourseOverview.vue")
			},
			{
				path: "exhibitorshall",
				name: "MainLobbyExhibitorsHall",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/Exbitorshall.vue")
			},
			{
				path: "sponsors",
				name: "MainLobbySponsors",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/SponsorList.vue")
			},
			{
				path: "sessions",
				name: "MainLobbySessions",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/session3.vue")
			},
			{
				path: "sessionsv2",
				name: "MainLobbySessions",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/sessions.vue")
			},
			{
				path: "resources",
				name: "MainLobbyResources",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/Resources.vue")
			},
			{
				path: "roundtable/:tid?",
				name: "MainLobbyRoundtable",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/RoundtableList.vue")
			},
			{
				path: "attendee/:aid?",
				name: "MainLobbyAttendee",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/AttendeeList.vue")
			}
		]
	},
	{
		path: "/lobby",
		name: "Lobby",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby.vue")
	},
	{
		path: "/lobby1",
		name: "Lobby1",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby1.vue")
	},
	{
		path: "/lobby2",
		name: "Lobby2",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby2.vue")
	},
	{
		path: "/lobby3",
		name: "Lobby3",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby3.vue")
	},
	{
		path: "/lobby4",
		name: "Lobby4",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby4.vue")
	},
	{
		path: "/lobby5",
		name: "Lobby5",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby5.vue")
	},
	{
		path: "/lobby6",
		name: "Lobby6",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Lobby6.vue")
	},
	{
		path: "/overview",
		name: "Analytics",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/analytics.vue")
	},
	{
		path: "/zoom-web",
		name: "ZoomWeb",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ZoomWeb.vue")
	},
	{
		path: "/zoom-vue",
		name: "ZoomWebVue",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ZoomWebVue.vue")
	},
	//{
	//	path: "/sessions/:tid?/:tname?",
	//	name: "session3",
	//	// route level code-splitting
	//	// this generates a separate chunk (about.[hash].js) for this route
	//	// which is lazy-loaded when the route is visited.
	//	component: () =>
	//		import(/* webpackChunkName: "about" */ "../views/session3.vue")
	//},
	{
		path: "/sessions/:tid?/:tname?",
		name: "Sessions",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/sessions.vue")
	},
	{
		path: "/admin-sessions/:tid?/:tname?",
		name: "AdminSessions",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SessionsAdmin.vue"),
		meta: {
			nextPath: "/admin-stageview"
		}
	},
	{
		path: "/createsession",
		name: "CreateSession",
			component: () =>
				import(/* webpackChunkName: "about" */ "../views/SessionAddEdit.vue")
	},
	{
		path: "/roundtablev2/:tid?",
		name: "RoundtableListv2",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RoundtableList-v2.vue")
	},
	{
		path: "/roundtable/:tid?/:type?/:name?",
		name: "RoundtableList",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RoundtableList-v2.vue")
	},
	{
		path: "/admin-roundtable/:tid?/:type?/:name?",
		name: "AdminRoundtableList",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RoundtableListAdmin.vue")
	},
	{
		path: "/roundtableold/:tid?",
		name: "RoundtableListOld",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RoundtableList.vue")
	},
	{
		path: "/eventlist",
		name: "EventList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventList.vue")
	},
	{
		path: "/myprofile/:editable?",
		name: "MyProfile",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/MyProfile.vue")
	},
	{
		path: "/myprofilev2/:editable?",
		name: "MyProfileV2",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/MyProfile-v2.vue")
	},
	{
		path: "/exhibitordetail/:sid",
		name: "ExhibitorDetails",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExhibitorDetails.vue")
	},
	{
		path: "/sponsors",
		name: "SponsorList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SponsorList.vue")
	},
	{
		path: "/sponsorsdetail/:sid",
		name: "SponsorsDetails",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SponsorsDetails.vue"),
		props: true
	},
	// {
	// 	path: '/attendee',
	// 	name: 'AttendeeList',
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ '../views/SponsorList.vue')
	// },
	{
		path: "/sessions3",
		name: "session3",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/session3.vue")
	},
	{
		path: "/socialwall",
		name: "SocialWall",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SocialWall.vue")
	},
	{
		path: "/info",
		name: "Info",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Info.vue")
	},
	{
		path: "/survey",
		name: "Survey",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Survey.vue")
	},
	{
		path: "/mymeetings",
		name: "MyMeetings",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/MyMeetings.vue")
	},

	{
		path: "/leaderboard/:tid?",
		name: "LeaderBoard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/LeaderBoard.vue")
	},

	{
		path: "/expoview/:sid?",
		name: "ExpoView",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExpoView.vue")
	},
	{
		path: "/exhibitorshall/:eid?/:type?",
		name: "ExhibitorsHall",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Exbitorshall.vue"),
		children: [
			//{
			//	path: "mymeetings",
			//	name: "MyMeetings1",
			//	component: () =>
			//		import(/* webpackChunkName: "about" */ "../views/MyMeetings.vue")
			//},
			{
				path: "livestage/:id?/:tid?",
				name: "livestage1",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/LiveStage.vue")
			}
		]
	},
	{
		path: "/exhibitorsview/:sid?/:name?/:nav?",
		name: "ExhibitorsView",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExpoView2.vue")
	},
	{
		path: "/openReg/:s?",
		name: "Registration",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Registration.vue")
	},
	{
		path: "/RegEvent/:c?",
		name: "EventListReg",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventListReg.vue")
	},
	{
		path: "/attendee/:aid?",
		name: "AttendeeList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AttendeeList.vue")
	},
	{
		path: "/admin-attendee/:aid?",
		name: "AdminAttendeeList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminAttendeeList.vue"),
		meta: {
			isAdminPage: true,
			nextPath: "/admin-speakers"
		}				
	},
	{
		path: "/myvcards/:aid?",
		name: "MyVCards",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/MyVCards.vue")
	},
	{
		path: "/wayfinder",
		name: "WayFinder",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/WayFinder.vue")
	},
	{
		path: "/speakers",
		name: "SpeakerList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SpeakerList.vue")
	},
	{
		path: "/admin-speakers",
		name: "AdminSpeakerList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminSpeakerList.vue"),
		meta: {
			isAdminPage: true,
			nextPath: "/admin-sessions"
		}
	},
	{
		path: "/speakerslounge",
		name: "SpeakersLounge",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SpeakersLounge.vue")
	},
	{
		path: "/SponsorsDetailsNew",
		name: "SponsorsDetailsNew",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SponsorsDetails-new.vue")
	},
	{
		path: "/SponsorList-new",
		name: "SponsorsListnew",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SponsorList-new.vue")
	},
	{
		path: "/sponsorlist-newdesign",
		name: "SponsorsListnewDesign",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
        /* webpackChunkName: "about" */ "../views/SponsorList-newDesign.vue"
			)
	},
	{
		path: "/event/:e/:en?",
		name: "Event",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Reg.vue")
	},
	{
		path: "/eventv3/:e/:en?",
		name: "Eventv3",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RegV3.vue")
	},
	{
		path: "/admin-event/:e/:en?",
		name: "AdminEvent",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RegV3Admin.vue"),
		meta: {
			isAdminPage: true,
		}
	},
	{
		path: "/reg-admin-eventv3/:e",
		name: "Eventv31",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/reg-admin-RegV3.vue")
	},
	{
		path: "/reg/:e?/:visitor?",
		name: "Reg",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Form.vue")
	},
	{
		path: "/regv3/:e?/:visitor?",
		name: "Reg3",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/FormV3.vue")
	},
	{
		path: "/admineventhub2",
		name: "AdminEventhub",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminEventhub.vue")
	},
	{
		path: "/register/:c?",
		name: "OpenEvent",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: EventListReg2
	},
	{
		path: "/events/:c?/:page_header?",
		name: "Events",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
		import(/* webpackChunkName: "about" */ "../views/Events.vue")
	},
	{
		path: "/eventstemplate1/:c?",
		name: "Events",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
		import(/* webpackChunkName: "about" */ "../views/EventsTemplate.vue")
	},
	{
		path: "/verifyuser/:sst?/:fn?/:ln?/:e?",
		name: "VerifyUser",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
		import(/* webpackChunkName: "about" */ "../views/VerifyUser.vue")
	},
	{
		path: "/regpaymentSuccess/:e?",
		name: "RegpaymentSuccess",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RegPaymentSuccess.vue")
	},
	{
		path: "/regpaymentFailure/:e?/:eid?",
		name: "regpaymentFailure",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RegPaymentFailure.vue")
	},
	{
		path: "/paymentstatus/:e/:eid",
		name: "PaymentStatus",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/RegPaymentRetry.vue")
	},
	{
		path: "ScreenErrorMessage",
		name: "ScreenErrorMessage",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ScreenErrorMessage.vue")
	},
	{
		path: "/loginexternal/:lt?",
		name: "LoginExternal",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/LoginExternal.vue")
	},
	{
		path: "/screeninfo",
		name: "ScreenInfo",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ScreenInfo.vue")
	},
	
	{
		path: "/changepass/:rt?",
		name: "ChangePass",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/changepassword.vue")
	},
	{
		path: "/exhibitorshalllite",
		name: "Exhibitorshalllite",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
        /* webpackChunkName: "about" */ "../views/ExhibitorshallMobile.vue"
			)
	},
	{
		path: "/exhibitorsboothlite",
		name: "exhibitorsboothlite",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
        /* webpackChunkName: "about" */ "../views/exhibitor-boothMobile.vue"
			)
	},
	{
		path: "/ext_widget/:type?",
		name: "Gamification",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Gamification.vue")
	},
	{
		path: "/createpass/:gpt?",
		name: "GeneratePass",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/generatepassword.vue")
	},
	{
		path: "/expohallaerialview",
		name: "Expohallariel",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Expohallariel.vue")
	},
	{
		path: "/expohallbirdview",
		name: "Expohallbird",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Expohallbird.vue")
	},
	{
		path: "/eventlistnew",
		name: "EventListnew",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventList.vue")
	},
	{
		path: "/resources",
		name: "Resources",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Resources.vue")
	},
	{
		path: "/expohallbirdview",
		name: "ExpohallBirdView",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
        /* webpackChunkName: "about" */ "../views/ExpohallarielBirdView.vue"
			)
	},
	{
		path: "/networkinglounge",
		name: "Newtorking Lounge",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/NetworkLounge.vue")
	},


	{
		path: "/admineventreglogin",
		name: "Admin Event Reg Login",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminEventLIstReg.vue")
	},

	{
		path: "/adminprofileedit",
		name: "Admin Profile Edit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminProfileEdit.vue")
	},

	{
		path: "/eventoverview",
		name: "AdminOverview",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AdminOverview.vue")
	},
	{
		path: "/page/:name?",
		name: "LandingPage",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/DynamicPage.vue")
		//children: [
		//	{
		//		path: "/appointment",
		//		name: "appointment",
		//		component: () =>
		//			import(/* webpackChunkName: "about" */ "../views/DynamicPage.vue")
		//	},
		//	{
		//		path: "networking-lounge",
		//		name: "networkinglounge",
		//		component: () =>
		//			import(/* webpackChunkName: "about" */ "../views/DynamicPage.vue")
		//	},
		//]
	},
	{
		path: "/join/:cid?/:eid?/:customer_guid",
		name: "Join",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Join.vue")
	},
	{
		path: "/joincms/:cid?/:eid?/:customer_guid",
		name: "JoinCMS",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Joincms.vue")
	},
	{
		path: "/showcase",
		name: "EventShowCase",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventShowCase.vue")
	},
	{
		path: "/eventsetup",
		name: "EventSetup",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventSetupBasicNew.vue"),
		meta: {
			nextPath: "/evenbranding"
		}
	},
	{
		path: "/basicinfo",
		name: "BasicInfo",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventBasicInfo.vue")		
	},
	{
		path: "/evenbranding",
		name: "EvenBranding",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/EventSetupBanner.vue"),
		meta: {
			nextPath: "/admin-attendee"
		}
	},
	{
		path: "/admin-exhibitorshall",
		name: "AdminExbitorshall",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExbitorshallAdmin.vue")
	},
	{
		path: "/expo-studio/:exhibitorid?",
		name: "ExpoViewAddEdit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/ExpoViewAddEdit.vue")
	},
	{
		path: "/provider/:providername?",
		name: "SocialLoginRedrictPage",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/SocialLoginRedrictPage.vue")
	},
	{
		path: "/programme",
		name: "Programme",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Programme.vue")
	},
	{
		path: "/partners",
		name: "Partners",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/Partners.vue")
	},
	{
		path: "/upcomingevents",
		name: "UpcomingEvents",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/UpcomingEvents.vue")
	},
	// New Interface start
	{
		path: "/login-new",
		name: "LoginNew",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/Login.vue")
	},
	{
		path: "/exhibitorshall-new/:eid?/:type?",
		name: "ExhibitorsHall",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Newinterface/Exbitorshall.vue"),
		children: [
			//{
			//	path: "mymeetings",
			//	name: "MyMeetings1",
			//	component: () =>
			//		import(/* webpackChunkName: "about" */ "../views/MyMeetings.vue")
			//},
			{
				path: "livestage/:id?/:tid?",
				name: "livestage1",
				component: () =>
					import(/* webpackChunkName: "about" */ "../views/LiveStage.vue")
			}
		]
	},
	{
		path: "/setupprofile",
		name: "Setupprofile",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/Setupprofile.vue")
	},
	{
		path: "/createavatar",
		name: "CreateAvatar",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/CreateAvatar.vue")
	},
	{
		path: "/lobbynew",
		name: "LobbyNew",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/LobbyNew.vue")
	},
	{
		path: "/roundtableroomone",
		name: "RoundtableRoomOne",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/roundtableRoomOne.vue")
	},
	{
		path: "/roundtableroomtwo",
		name: "roundtableRoomTwo",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/roundtableRoomTwo.vue")
	},
	{
		path: "/roundtableroomthree",
		name: "roundtableRoomThree",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/roundtableRoomThree.vue")
	},
	{
		path: "/matchmacking",
		name: "Matchmacking",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/Newinterface/matchmacking.vue")
	},
	// New Interface end
	// Chat GPT Routs
	{
		path: "/welcome",
		name: "Welcome",
		//component: () => import("../views/Newinterface/LoginNew.vue")
		component: () => import(/* webpackChunkName: "about" */ "../views/ChatGpt/WelcomePage.vue")
	},
	// Chat GPT Routs
	{
		path: "/event-diagnostic",
		name: "EventDiagnostic",
		meta: { public: true },
		component: () =>
			import(/* webpackChunkName: "event-diagnostic" */ "../views/EventDiagnostic.vue")
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
//alert("aaa");
	return next();
});

export default router;
